// extracted by mini-css-extract-plugin
export default {"menuListItem":"brand-global-nav-menus-MenuListItem__menuListItem--2ZG-3","subItemIndicator":"brand-global-nav-menus-MenuListItem__subItemIndicator--1UuWZ"};